import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useDamageCategoryReducer = () =>
  useSelector((state: ApplicationState) => state.damageCategory);
